import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { useState, useEffect } from "react";
import QRCode from "qrcode";
import axios from "axios";
import baseURL from "../../../../Url/NodeBaseURL";
// Use local logo to avoid CORS issues
const logo1 = "/sadashri_logo-bnw.png";




const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 9 },
  header: { fontSize: 20, textAlign: "right" },
  estimateInfo: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginBottom: 5,
  },
  estimateMeta: {
    fontSize: 9,
    textAlign: "left",
    marginLeft: -20,
    marginTop: 5,
  },
  estimateNo: { fontSize: 11, marginBottom: 5 },
  topRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 15,
  },
  logoSection: { flex: 1, alignItems: "flex-start" },
  logo: { width: 150 },
  logoText: { 
    fontSize: 16, 
    fontWeight: "bold", 
    marginBottom: 10,
    textAlign: "center"
  },
  leftInfo: { marginTop: 15 },
  leftText: { fontSize: 12, marginBottom: 5 },
  todaysRate: {
    fontSize: 10,
    color: "gray",
    fontStyle: "italic",
    marginTop: 5,
  },
  qrRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    marginTop: 5,
  },
  qr: { width: 50, height: 50, marginRight: 10 },
  qrMeta: { fontSize: 8, flexDirection: "column", marginTop: 6 },
  rightSection: { flex: 1, alignItems: "flex-end" },
  dottedLine: { borderTop: "1 dashed black", marginVertical: 12 },
  categoryTitle: {
    fontSize: 8,
    marginTop: 10,
    backgroundColor: "#f0f0f0",
    padding: 2,
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: "1 solid #000",
    marginTop: 4,
    fontSize: 8,
  },
  remarkRow: {
    backgroundColor: "#f5f5f5",
    padding: 3,
    fontSize: 7,
  },
  row: {
    flexDirection: "row",
    borderBottom: "1 solid #ccc",
    paddingVertical: 4,
    fontSize: 7,
  },
  cell: { width: "11%", textAlign: "center" },
  cellSmall: { width: "10%", textAlign: "center" },
  cellMedium: { width: "15%", textAlign: "center" },
  cellLarge: { width: "25%", textAlign: "center" },
  totalSection: {
    marginTop: 10,
    alignSelf: "flex-end",
    width: "35%",
    paddingRight: 0,
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 3,
    fontSize: 8,
  },
  totalLabel: { flex: 1 },
  totalAmount: { flex: 1, textAlign: "right" },
  bold: { fontWeight: "bold" },
  italic: { fontStyle: "italic" },
  footer: { marginTop: 30, textAlign: "center", fontSize: 12 },
  link: { color: "blue", textDecoration: "underline" },
  // New styles for URD purchase and sales return
  sectionTitle: {
    fontSize: 10,
    fontWeight: "bold",
    marginTop: 15,
    marginBottom: 5,
    backgroundColor: "#e9ecef",
    padding: 3,
  },
  deductionRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 3,
    fontSize: 8,
  },
  deductionLabel: { flex: 1 },
  deductionAmount: { flex: 1, textAlign: "right", color: "red" },
  netPayableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 8,
    fontSize: 9,
    fontWeight: "bold",
    backgroundColor: "#f8f9fa",
    padding: 3,
  },
  netPayableLabel: { flex: 1, fontWeight: "bold" },
  netPayableAmount: { flex: 1, textAlign: "right", fontWeight: "bold" },
});

const EstimateA4 = ({ 
  formData, 
  items, 
  subtotal, 
  cgst, 
  sgst, 
  grandTotal,
  urdPurchaseData = [],
  urdPurchaseAmount = 0,
  salesReturnData = [],
  salesReturnAmount = 0,
  netPayableAmount = null,
  festivalDiscountAmt = 0
}) => {

  console.log("formData", formData);
  console.log("items", items);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [logoError, setLogoError] = useState(false);
  const [currentRates, setCurrentRates] = useState({
    rate_16crt: "",
    rate_18crt: "",
    rate_22crt: "",
    rate_24crt: "",
    silver_rate: "",
  });

  useEffect(() => {
    QRCode.toDataURL("https://forms.gle/your-form-id")
      .then(setQrCodeUrl)
      .catch((err) => console.error("QR code generation failed:", err));
  }, []);

  // Fetch current rates
  useEffect(() => {
    const fetchCurrentRates = async () => {
      try {
        const response = await axios.get(`${baseURL}/get/current-rates`);
        if (response.data) {
          setCurrentRates({
            rate_16crt: response.data.rate_16crt || "",
            rate_18crt: response.data.rate_18crt || "",
            rate_22crt: response.data.rate_22crt || "",
            rate_24crt: response.data.rate_24crt || "",
            silver_rate: response.data.silver_rate || "",
          });
        }
      } catch (error) {
        console.error("Error fetching current rates:", error);
      }
    };

    fetchCurrentRates();
  }, []);


  const groupedItems = items.reduce((acc, item) => {
    if (!acc[item.categoty]) acc[item.categoty] = [];
    acc[item.categoty].push(item);
    return acc;
  }, {});

  // Calculate total number of items
  const totalItems = items.length;

  const totalDiscount = items.reduce(
    (sum, item) => sum + (parseFloat(item.discount) || 0),
    0
  );

  // Calculate total festival discount from items (fallback to prop if items don't have it)
  const totalFestivalDiscount = items.reduce((sum, item) => sum + (parseFloat(item.festivalDiscount) || 0), 0) || festivalDiscountAmt;
  console.log("totalFestivalDiscount", totalFestivalDiscount);
  console.log("items", items);
  const formatDate = (str) => {
    const date = new Date(str);
    return `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  };

  // Calculate final amount after deductions
  // Use netPayableAmount from database if available, otherwise calculate
  const finalAmount = netPayableAmount !== null ? parseFloat(netPayableAmount) : 
    (parseFloat(grandTotal) || 0) - (parseFloat(urdPurchaseAmount) || 0) - (parseFloat(salesReturnAmount) || 0);
  
  // Round off the final amount to nearest whole number
  const roundedFinalAmount = Math.round(finalAmount);
  

  // Helper function to safely render text
  const safeText = (value) => {
    if (value === null || value === undefined || value === "") {
      return " ";
    }
    return value.toString();
  };

  const newSubtotal = items.reduce((sum, item) => sum + (parseFloat(item.value) - parseFloat(item.tax_amt) + parseFloat(item.festivalDiscount) + parseFloat(item.discount) || 0), 0);
  console.log("newSubtotal", newSubtotal);
  // Helper function to format MC value based on MC type
  const formatMCValue = (mcType, mcValue) => {
    if (!mcValue || mcValue === 0) return "0";
    
    switch (mcType) {
      case "MC %":
        return `${mcValue}%`;
      case "MC / Gram":
        return `${mcValue}/gm`;
      case "MC / Piece":
        return `${mcValue}`;
      default:
        return mcValue.toString();
    }
  };

  return (
    <Document>
      <Page size="A5" style={styles.page}>
        <View style={styles.topRow}>
          <View style={styles.logoSection}>
          {!logoError  ? (
              <Image 
                src={logo1} 
                style={styles.logo}
                onError={() => setLogoError(true)}
              />
            ) : (
              <Text style={styles.logoText}>SADA SHRI JEWEL KART</Text>
            )}

            <View style={styles.leftInfo}>
              <Text style={styles.leftText}>
                Customer Care: +91 99646 44424
              </Text>
              <Text style={styles.todaysRate}>TODAY'S RATE</Text>
              <Text style={styles.todaysRate}>24K | 99.9% GOLD: {currentRates.rate_24crt || "N/A"}/gm</Text>
              <Text style={styles.todaysRate}>22K | 91.6% GOLD: {currentRates.rate_22crt || "N/A"}/gm</Text>
              <Text style={styles.todaysRate}>18K | 75% GOLD: {currentRates.rate_18crt || "N/A"}/gm</Text>
              <Text style={styles.todaysRate}>SILVER: {currentRates.silver_rate || "N/A"}/gm</Text>
            </View>
          </View>

          <View style={styles.rightSection}>
            <Text style={styles.header}>ESTIMATE</Text>
            <Text style={styles.estimateNo}>#: {safeText(formData.estimate)}</Text>
            <View style={styles.qrRow}>
            {qrCodeUrl && <Image src={qrCodeUrl} style={styles.qr} />}
              <View style={styles.qrMeta}>
                <Text>DATE:</Text>
                <Text>{formatDate(formData.date || new Date())}</Text>
                <Text>TIME:</Text>
                <Text>{safeText(formData.time)}</Text>
              </View>
            </View>
            <View style={styles.qrRow}>
              <View style={styles.estimateMeta}>
                <Text>NAME: {safeText(formData.customerName)}</Text>
                <Text>PH: {safeText(formData.mobile)}</Text>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.dottedLine} />

        {/* Determine if we have any fixed pricing items (no weight but has value) */}
        {(() => {
          const hasFixedPricingItems = items.some(item => {
            const weight = parseFloat(item.weight) || 0;
            const value = parseFloat(item.value) || 0;
            return weight === 0 && value > 0;
          });
          
          return hasFixedPricingItems ? (
            // Fixed pricing header - simplified columns
            <View style={styles.tableHeader}>
              <Text style={styles.cellSmall}>SNO</Text>
              <Text style={styles.cellLarge}>ITEM</Text>
              <Text style={styles.cellMedium}>QTY</Text>
              <Text style={styles.cellMedium}>RATE</Text>
              <Text style={styles.cellMedium}>VALUE</Text>
            </View>
          ) : (
            // Weight-based pricing header - full columns
            <View style={styles.tableHeader}>
              <Text style={styles.cellSmall}>SNO</Text>
              <Text style={styles.cellLarge}>ITEM</Text>
              <Text style={styles.cellMedium}>Purity</Text>
              <Text style={styles.cellMedium}>RATE</Text>
              <Text style={styles.cellMedium}>WEIGHT</Text>
              <Text style={styles.cellSmall}>VA%</Text>
              <Text style={styles.cellSmall}>{totalItems === 1 && items[0]?.mcType ? items[0].mcType : 'MC'}</Text>
              <Text style={styles.cellMedium}>VALUE</Text>
            </View>
          );
        })()}

        {Object.entries(groupedItems).length > 0 ? Object.entries(groupedItems).map(([category, categoryItems]) => (
          <View key={category}>
            <Text style={styles.categoryTitle}>{safeText(category || 'General')}</Text>
            {categoryItems.map((item, index) => {
              // Determine if this item uses fixed pricing
              const weight = parseFloat(item.weight) || 0;
              const value = parseFloat(item.value) || 0;
              const isFixedPricing = weight === 0 && value > 0;
              
              return isFixedPricing ? (
                // Fixed pricing row - simplified columns
                <View style={styles.row} key={index}>
                  <Text style={styles.cellSmall}>{(index + 1).toString()}</Text>
                  <Text style={styles.cellLarge}>{safeText(item.item)}</Text>
                  <Text style={styles.cellMedium}>{(item.printing_purity)}</Text>
                  <Text style={styles.cellMedium}>{safeText(item.qty || "1")}</Text>
                  <Text style={styles.cellMedium}>{safeText(item.rate)}</Text>
                  <Text style={styles.cellMedium}>{safeText(parseFloat(item.value - item.tax_amt + parseFloat(item.festivalDiscount) + parseFloat(item.discount)).toFixed(2))}</Text>
                </View>
              ) : (
                // Weight-based pricing row - full columns
                <View style={styles.row} key={index}>
                  <Text style={styles.cellSmall}>{(index + 1).toString()}</Text>
                  <Text style={styles.cellLarge}>{safeText(item.item)}</Text>
                  <Text style={styles.cellMedium}>{(item.printing_purity)}</Text>
                  <Text style={styles.cellMedium}>{safeText(item.rate)}</Text>
                  <Text style={styles.cellMedium}>{safeText(item.weight)}</Text>
                  <Text style={styles.cellSmall}>{safeText(item.vaPercent || item.wastagePercent || "0")}</Text>
                  <Text style={styles.cellSmall}>{safeText(formatMCValue(item.mcType, item.mcValue))}</Text>
                  <Text style={styles.cellMedium}>{safeText(parseFloat(item.value - item.tax_amt + parseFloat(item.festivalDiscount) + parseFloat(item.discount)).toFixed(2))}</Text>
                </View>
              );
            })}
          </View>
        )) : (
          // No items fallback - check if we have fixed pricing items to determine header
          (() => {
            const hasFixedPricingItems = items.some(item => {
              const weight = parseFloat(item.weight) || 0;
              const value = parseFloat(item.value) || 0;
              return weight === 0 && value > 0;
            });
            
            return hasFixedPricingItems ? (
              // Fixed pricing fallback row
              <View style={styles.row}>
                <Text style={styles.cellSmall}>1</Text>
                <Text style={styles.cellLarge}>No items</Text>
                <Text style={styles.cellMedium}>0</Text>
                <Text style={styles.cellMedium}>0</Text>
                <Text style={styles.cellMedium}>0</Text>
              </View>
            ) : (
              // Weight-based pricing fallback row
              <View style={styles.row}>
                <Text style={styles.cellSmall}>1</Text>
                <Text style={styles.cellLarge}>No items</Text>
                <Text style={styles.cellMedium}>0</Text>
                <Text style={styles.cellMedium}>0 GM</Text>
                <Text style={styles.cellSmall}>0</Text>
                <Text style={styles.cellSmall}>MC %</Text>
                <Text style={styles.cellMedium}>0</Text>
              </View>
            );
          })()
        )}

        {/* Two-column layout: Remarks on left, Totals on right */}
        <View style={{ flexDirection: "row", marginTop: 10, justifyContent: "space-between" }}>
          {/* Left column - Remarks */}
          <View style={{ width: "60%", marginRight: 10 }}>
            <Text style={{...styles.sectionTitle, display: items.filter(item => item.remark_value && String(item.remark_value).trim().length > 0).length > 0 ? "block" : "none" }}>Remarks</Text>
            {items
                .filter(item => item.remark_value && item.remark_type && item.remark_type == "Client Facing" && String(item.remark_value).trim().length > 0)
                .map((item, index) => (
                  <View key={index} style={styles.remarkRow}>
                    <Text style={{ fontSize: 7, whiteSpace: "pre-wrap" }}>
                      {index + 1}.{item.item} {item.remark_value}
                    </Text>
                  </View>
                ))
            }
          </View>

          {/* Right column - Totals */}
          <View style={{ width: "35%", alignSelf: "flex-end" }}>
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Subtotal:</Text>
              <Text style={styles.totalAmount}>{newSubtotal.toFixed(2)}</Text>
            </View>
            
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Total Discount:</Text>
              <Text style={styles.totalAmount}>{(parseFloat(totalDiscount) || 0).toFixed(2)}</Text>
            </View>
            
            {(parseFloat(totalFestivalDiscount) || 0) > 0 && (
              <View style={styles.totalRow}>
                <Text style={{ ...styles.totalLabel, color: "green" }}>Festival Discount:</Text>
                <Text style={{ ...styles.totalAmount, color: "green" }}>{(parseFloat(totalFestivalDiscount) || 0).toFixed(2)}</Text>
              </View>
            )}
            
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>CGST @1.5%:</Text>
              <Text style={styles.totalAmount}>{(parseFloat(cgst) || 0).toFixed(2)}</Text>
            </View>
            
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>SGST @1.5%:</Text>
              <Text style={styles.totalAmount}>{(parseFloat(sgst) || 0).toFixed(2)}</Text>
            </View>
            
            {(parseFloat(urdPurchaseAmount) || 0) > 0 && (
              <View style={styles.deductionRow}>
                <Text style={styles.deductionLabel}>URD Purchase Amount:</Text>
                <Text style={styles.deductionAmount}>-{(parseFloat(urdPurchaseAmount) || 0).toFixed(2)}</Text>
              </View>
            )}

            {(parseFloat(salesReturnAmount) || 0) > 0 && (
              <View style={styles.deductionRow}>
                <Text style={styles.deductionLabel}>Sales Return Amount:</Text>
                <Text style={styles.deductionAmount}>-{(parseFloat(salesReturnAmount) || 0).toFixed(2)}</Text>
              </View>
            )}

            <View style={styles.netPayableRow}>
              <Text style={styles.netPayableLabel}>Net Payable Amount:</Text>
              <Text style={styles.netPayableAmount}>{roundedFinalAmount.toFixed(0)}</Text>
            </View>
          </View>
        </View>

        <View style={styles.footer}>
          <Text>Give us feedback @ GOOGLE FORMLINK</Text>
          <Text style={styles.link}>
            Visit us: www.sadashrijewelkart.com
          </Text>
          <Text>Store Open: 9:30AM To 9:30PM Daily</Text>
        </View>
      </Page>
    </Document>
  );
};

export default EstimateA4;